import type { UseMutationOptions } from 'react-query';
import { useQueryClient, useMutation } from 'react-query';

import { apiClient } from '../apiClient';
import type { ILead } from '../types/lead';
import type { IRequestException } from '../types/requestException';

interface IPutResponse {
    leadId: ILead['leadId'];
    note: string;
}

interface IPutNoteProps {
    id: ILead['leadId'];
    note: string;
}

interface IPutNoteContext {
    runningRequests: number;
}

const putNote = async ({ id, note }: IPutNoteProps) => {
    const response = await apiClient.put(`edms/${id}/notes`, {
        json: {
            note,
        },
    });
    return (await response.json()) as IPutResponse;
};

export const usePutNoteMutation = (
    options: UseMutationOptions<
        IPutResponse,
        IRequestException,
        IPutNoteProps,
        IPutNoteContext
    >
) => {
    const queryClient = useQueryClient();
    return useMutation<
        IPutResponse,
        IRequestException,
        IPutNoteProps,
        IPutNoteContext
    >(async (props) => await putNote(props), {
        onSuccess: (data, variables) => {
            // just invalidate property-lead cache instead of trying to update it
            void queryClient.invalidateQueries('property-lead');
        },
        ...options,
    });
};
